module.exports = __webpack_public_path__ + "static/media/logo.10f43512.png";